// Tour Curator — top-level route, gated behind VITE_FF_TOUR_CURATOR.
// -----------------------------------------------------------------
// Per docs/architecture/dispatches/m7-1-producer-pipeline.md § 4.3.
//
// Replaces the Flask /tour-curator page
// (admin/routes/tour_curator.py). When the flag is off (the default
// in both staging and prod), the route mounts and immediately
// <Navigate replace />s to /hello — matching the M3.4 placeholder
// pattern used by Tour Planner and Prompts.
//
// Flag flips at M7.1-L1 staging + M7.1-L2 prod per dispatch § 5.
// The Flask page itself remains accessible (localhost-only) until
// M7.1-L3 retirement.

import { Navigate, createFileRoute } from '@tanstack/react-router';

import { TourCuratorPage } from '@/components/tour-curator/TourCuratorPage';
import { isFeatureEnabled } from '@/lib/featureFlags';

const TourCuratorRoute = () => {
  if (!isFeatureEnabled('TOUR_CURATOR')) {
    return <Navigate to='/hello' replace />;
  }
  return <TourCuratorPage />;
};

export const Route = createFileRoute('/_authenticated/tour-curator')({
  component: TourCuratorRoute,
});
